















import { Component, Prop, Inject, Vue } from "vue-property-decorator";
import { IBulkActionProvider } from "@/models/providers/bulkAction";
import getProgressAndStatus from "@/components/app/admin/automation/getProgressAndStatus";
import { serialiseConfig } from "@/helpers/table";
import { FilterOperators } from "@/data/table";

@Component({
  components: {
    "stat-view": () => import("@/components/app/global/stats/stat/statView.vue")
  }
})
export default class BulkActionStats extends Vue {
  @Inject({ from: "bulkActionProvider" })
  public readonly $bulkActionProviderData!: () => IBulkActionProvider;

  // Props
  @Prop({ required: true })
  public resultsRouteName!: string;

  public get provider() {
    return this.$bulkActionProviderData();
  }

  public get bulkAction() {
    return this.provider.bulkAction;
  }

  public get progressAndStatus() {
    return getProgressAndStatus(this.bulkAction);
  }

  public get statistics() {
    let duration = this.$moment.duration(
      this.$moment(this.bulkAction.completed_at).diff(
        this.bulkAction.started_at
      )
    );

    if (
      this.$moment(this.bulkAction.completed_at).isBefore(
        this.bulkAction.started_at
      )
    ) {
      duration = this.$moment.duration(0);
    }

    return [
      {
        label: this.$t("_.scheduled"),
        value: this.bulkAction.num_scheduled
      },
      {
        label: this.$t("_.successful"),
        value: this.$_.get(this.bulkAction, "num_successful", 0),
        to: {
          name: this.resultsRouteName,
          query: {
            BAR1: serialiseConfig({
              filters: [
                {
                  key: "successful",
                  operator: FilterOperators.EQUAL,
                  value: "1"
                }
              ]
            })
          }
        }
      },
      {
        label: this.$t("_.failed"),
        value: this.$_.get(this.bulkAction, "num_failed", 0),
        to: {
          name: this.resultsRouteName,
          query: {
            BAR1: serialiseConfig({
              filters: [
                {
                  key: "successful",
                  operator: FilterOperators.EQUAL,
                  value: "0"
                }
              ]
            })
          }
        }
      },
      {
        label: this.$t("_.duration"),
        value:
          this.$_.round(duration.asSeconds()) < 60
            ? this.$tc("_plurals.second", this.$_.round(duration.asSeconds()))
            : this.$tc("_plurals.minute", this.$_.round(duration.asMinutes()))
      },
      {
        label: this.$t("_.complete"),
        value: `${this.$_.round(
          this.$_.get(this.progressAndStatus, "value", 0)
        )}%`
      }
    ];
  }
}
